import { AlertTriangle, Check, Cloud, CloudOff, RefreshCw, X } from 'lucide-react';
import { MirrorWord } from './branding.jsx';

export function SyncPill({ sync, onAbort, onResume }) {
  const Icon = sync.state === 'synced' ? Check : sync.state === 'offline' ? CloudOff : sync.state === 'attention' ? AlertTriangle : sync.state === 'syncing' ? RefreshCw : Cloud;
  const canStop = onAbort && ['syncing', 'cooldown', 'offline', 'attention'].includes(sync.state);
  return <div className={`sync-pill ${sync.state}`} role="status" aria-live="polite"><Icon /><span className="sync-pill-copy"><strong>{sync.label}</strong>{sync.detail ? <small>{sync.detail}</small> : null}</span>{canStop ? <button type="button" className="sync-pill-action" onClick={onAbort}><X /> Stop sync</button> : null}{sync.state === 'paused' && onResume ? <button type="button" className="sync-pill-action" onClick={onResume}>Resume</button> : null}</div>;
}

export function SyncConflict({ conflict, onResolve, onCancel }) {
  if (!conflict) return null;
  return <div className="sync-conflict-layer" role="dialog" aria-modal="true" aria-labelledby="sync-conflict-title">
    <section className="sync-conflict-card">
      <AlertTriangle />
      <span>Sync decision</span>
      <h2 id="sync-conflict-title"><MirrorWord /> found changes from another device.</h2>
      <p>Choose which complete wardrobe should become the synced copy. Nothing changes until you choose.</p>
      <button onClick={() => onResolve('device')}>Keep this device</button>
      <button onClick={() => onResolve('cloud')}>Use synced version</button>
      {onCancel ? <button className="sync-conflict-cancel" onClick={onCancel}><X /> Stop sync &amp; keep local</button> : null}
    </section>
  </div>;
}
